import Logo from '@locus-labs/mol-desktop-logo'
import React from 'react'
import styled from 'styled-components'

import { ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'
import { getThemeColor } from '../../../../../src/utils/styled-component-tools.js'

const TopBar = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`

const CloseButton = styled.button`
  color: ${getThemeColor('widgetText', '#333333')};
  border: none;
  background: none;
  font-size: 12px !important;
  padding: 0;
`

const LogoAndCloseButton = ({ logoUrl, theme, isMobile, clientName, onClose, T }) => {
  const showLogo = logoUrl && theme.header.hasLogo

  return (
    <TopBar>
      {showLogo && (
        <Logo
          logoHeight={isMobile ? '28px' : theme.logo.height}
          alt={clientName}
          url={logoUrl}
          width="auto"
          position={theme.logo.centered ? 'center' : 'left'}
          padding={theme.logo.padding}
        />
      )}
      {!showLogo && <span>&nbsp;&nbsp;</span>}
      <CloseButton onClick={onClose} data-cy='CloseButton' aria-label={T('ui:Close')}>
        <ColoredIcon
          className="icon"
          width={32}
          height={32}
          id="close"
          fillColor={theme.colors.secondaryText}
        />
      </CloseButton>
    </TopBar>)
}

export default LogoAndCloseButton
